const trimSlash = (value) => String(value || "").trim().replace(/\/+$/, "");

const isProduction = () =>
  process.env.NODE_ENV === "production" ||
  process.env.SERVER_ENV === "production";

const PROD_SITE = "https://book.gerelt.mn";
const PROD_API = `${PROD_SITE}/api`;
const DEV_API = "http://localhost:5023/api/v1/public";
const DEV_SITE = "http://localhost:3000";
const DEV_CDN = "http://localhost:5023/uploads";

const isProdApiHost = (url) =>
  isProduction() || /book\.gerelt\.mn/i.test(url);

/**
 * Prod (nginx): https://book.gerelt.mn/api/webinfo
 * Dev (шууд service): http://localhost:5023/api/v1/public/webinfo
 */
export function resolveApiUrl(raw = "") {
  let value = trimSlash(
    raw ||
      process.env.NEXT_PUBLIC_API_URL ||
      process.env.API_URL ||
      "",
  );

  if (!value) {
    return isProduction() ? PROD_API : DEV_API;
  }

  if (isProdApiHost(value)) {
    return value
      .replace(/\/api\/v1\/public$/i, "/api")
      .replace(/\/api\/v1$/i, "/api");
  }

  if (value.endsWith("/api/v1/public")) return value;
  if (value.endsWith("/api/v1")) return `${value}/public`;
  if (value.endsWith("/api")) return `${value}/v1/public`;

  return value;
}

export function resolveBaseUrl(raw = "") {
  const value = trimSlash(
    raw ||
      process.env.NEXT_PUBLIC_BASE_URL ||
      process.env.BASE_URL ||
      "",
  );

  if (!value) {
    return isProduction() ? PROD_SITE : DEV_SITE;
  }

  return value;
}

export function resolveCdnUrl(raw = "") {
  const value = trimSlash(
    raw ||
      process.env.NEXT_PUBLIC_CDN_URL ||
      process.env.CDN_URL ||
      "",
  );

  if (!value) {
    return isProduction() ? `${PROD_SITE}/uploads` : DEV_CDN;
  }

  return value;
}
